import { LDEvaluationDetail } from 'launchdarkly-node-server-sdk';
import { UI_FEATURE_FLAGS } from '@/constants';
import { useFeatureFlags } from '@/components/contexts/FeatureFlagsContext';

type ClientFeatureFlags = keyof typeof UI_FEATURE_FLAGS;
type FlagName = (typeof UI_FEATURE_FLAGS)[ClientFeatureFlags]['id'];

export default function useFeatureFlag(flagName: FlagName): LDEvaluationDetail | undefined {
  const featureFlags = useFeatureFlags();
  return featureFlags?.flags?.[flagName];
}
